import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import POSAction from "../stores/actions/POSAction";

const UpdatePOSCart = ({ productId, cartQty, cartData, minSaleQty }: any) => {
  const dispatch = useDispatch<any>();
  const [updateLoader, setUpdateLoader] = useState<boolean>(false);
  const [updateCartQty, setUpdateCartQty] = useState<any>(0);
  const [tempQty, setTempQty] = useState<any>(0);
  const addCount = async () => {
    setUpdateCartQty(cartQty + Number(minSaleQty));
    await updateQty("increase", cartQty + Number(minSaleQty));
  };
  const minusCount = async () => {
    setUpdateCartQty(cartQty - Number(minSaleQty));
    await updateQty("decrease", cartQty - Number(minSaleQty));
  };

  const updateQty = async (action: any, qtyCount: number) => {
    setUpdateLoader(true);
    try {
      await dispatch(
        POSAction.updateCart({
          id: productId,
          action: action,
          qty: qtyCount,
        })
      );
      setUpdateLoader(false);
      await cartData();
    } catch (error: any) {
      setUpdateLoader(false);
      toast.error(error.message);
    }
  };

  // const updateQtyBulk = async () => {
  //   if (Number(updateCartQty) <= minSaleQty) {
  //     toast.error(`"Please enter minimum ${minSaleQty} qty"`);
  //     return false;
  //   }
  //   setUpdateLoader(true);
  //   try {
  //     await dispatch(
  //       POSAction.updateCart({
  //         id: productId,
  //         action: "input",
  //         qty: updateCartQty,
  //       })
  //     );
  //     setUpdateCartQty(updateCartQty);
  //     setUpdateLoader(false);
  //     await cartData();
  //   } catch (error: any) {
  //     setUpdateLoader(false);
  //     toast.error(error.message);
  //   }
  // };

  useEffect(() => {
    setUpdateCartQty(cartQty);
    setTempQty(cartQty);
  }, [cartQty]);

  const handleBlur = async () => {
    const stateQty: any = Number(tempQty);

    if (stateQty === 0) {
      setUpdateCartQty(updateCartQty);
      setTempQty(updateCartQty);
      return false;
    }

    if (stateQty % minSaleQty === 0) {
      setUpdateCartQty(stateQty);
      setTempQty(stateQty);
      await updateQty("input", stateQty);
    } else {
      let storeQty: any = Math.round(stateQty / minSaleQty) * minSaleQty;
      if (storeQty > 0 && stateQty >= minSaleQty) {
        setUpdateCartQty(storeQty);
        setTempQty(storeQty);
        await updateQty("input", storeQty);
      } else {
        setUpdateCartQty(updateCartQty);
        setTempQty(updateCartQty);
        await updateQty("input", updateCartQty);
      }
    }
  };

  return (
    <>
      <div className="d-flex">
        <button
          type="button"
          onClick={minusCount}
          className="btn btn-primary btn-sm rounded-0 w-100"
          disabled={updateLoader}>
          -
        </button>
        {updateLoader ? (
          <i className={"fa fa-spinner fa-spin"}></i>
        ) : (
          <input
            className="text-center border-gray"
            type="text"
            style={{ width: 30 }}
            value={tempQty}
            min={minSaleQty}
            onChange={(e: any) => setTempQty(e.target.value)}
            onBlur={handleBlur}
            readOnly={updateLoader}
          />
        )}
        <button
          type="button"
          onClick={addCount}
          className="btn btn-primary btn-sm rounded-0 w-100"
          disabled={updateLoader}>
          +
        </button>
      </div>
    </>
  );
};

export default UpdatePOSCart;
